import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchNegocioData = async (id) => {
    try { 
        const response = await axios.get(`${API_URL}/api/negocio/${id}`, {
            headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchDepartamentosFiltersData = async (negocio) => {
    try {
        const response = await axios.post(`${API_URL}/api/departamentos/filters`, {

            "current_page": 1,
            "items_per_page": 1000,
            "filteredWord": null,
            "negocio": negocio,
            "tipo": "organigrama",
        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchNegociosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/negocios`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


/* ORGANIGRAMA · a quien pinta, y por que NO es `activo`.
 *
 * El criterio es **la situacion: «Alta»**. `estadoAlta` es el id, que lo resuelve el componente
 * buscandolo POR NOMBRE en la tabla `estados` — no se escribe aqui aunque sea 3 en los tres
 * entornos, porque un identificador se mira y no se deduce.
 *
 * ── POR QUE NO `activo: true`, QUE ES LO QUE PARECE ──────────────────────────────────────
 *
 * Hasta Fase D esta llamada no mandaba NADA y recibia solo activos igualmente: `/personas/filters`
 * arrancaba con un suelo `activo: true` fijo. Al quitar ese suelo hubo que elegir criterio, y
 * `activo` no es el bueno por dos razones:
 *
 *   · `activo` es un campo DERIVADO de la situacion desde Fase 14. Preguntar por el derivado
 *     cuando existe el original es quedarse a merced de que la derivacion siga siendo correcta
 *   · y sobre todo: `activo = 1` incluye **las fichas incoherentes**. Medido al hacer el cambio,
 *     en local y TEST hay personas con estado «Baja» y `activo = 1`. Con `activo: true` el
 *     organigrama las pintaria — gente de baja, dibujada como plantilla, por un fallo de datos
 *
 * En produccion los dos criterios dan hoy el mismo numero (224). **Es coincidencia, no
 * equivalencia**: alli no hay incoherencias. Mirar solo produccion llevaria a concluir que da
 * igual cual se use.
 *
 * ── LO QUE QUEDA FUERA, Y NO ES UN OLVIDO ────────────────────────────────────────────────
 *
 * «En proceso» queda fuera a proposito: esa persona todavia no ha empezado a trabajar.
 *
 * «Baja medica» tambien queda fuera, y ESO SI ES UNA PREGUNTA ABIERTA: quien esta de baja medica
 * sigue contratado y sigue en su puesto, asi que su jefe probablemente sigue siendo su jefe.
 * **No se decidio porque no hace falta**: hay CERO personas en ese estado en los tres entornos.
 * Cuando aparezca la primera, es una decision de negocio y no de filtro.
 */
export const fetchPersonasFiltersData = async (negocio, estadoAlta) => {
    try {
        const response = await axios.post(`${API_URL}/api/personas/filters`, {

            "current_page": 1,
            "items_per_page": 1000,
            "filteredWord": null,
            "rol": null,
            "departamento": null,
            "negocio": negocio,
            "estado": estadoAlta,

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

// Organigrama · Asesorías por negocio.
// GET → array de filas [{ id, asesor_de_id, asesorado_de_id, nota,
//                         asesor_departamento_id, asesorado_departamento_id }]
export const fetchAsesoriasOrganigrama = async (negocioId) => {
    try {
        const response = await axios.get(`${API_URL}/api/organigrama/asesorias`, {
            params: { negocio: negocioId },
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Organigrama · Posiciones manuales del lienzo por departamento.
// GET → { [departamento_empresa_id]: { x, y }, ... } (solo las guardadas).
export const fetchPosicionesOrganigrama = async (negocioId) => {
    try {
        const response = await axios.get(`${API_URL}/api/organigrama/posiciones`, {
            params: { negocio: negocioId },
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        });
        return response.data || {};
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Guarda (UPSERT) las posiciones manuales del negocio.
// posiciones = { [de_id]: { x, y } } o array de { departamento_empresa_id, x, y }.
export const savePosicionesOrganigrama = async (negocioId, posiciones) => {
    try {
        const response = await axios.put(`${API_URL}/api/organigrama/posiciones`,
            { posiciones },
            {
                params: { negocio: negocioId },
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Borra todas las posiciones manuales del negocio → vuelve al layout
// automático de dagre al recargar.
export const resetPosicionesOrganigrama = async (negocioId) => {
    try {
        const response = await axios.put(`${API_URL}/api/organigrama/posiciones`,
            { reset: true },
            {
                params: { negocio: negocioId },
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Reemplazo transaccional de asesorías del negocio.
// body = { asesorias: [{ asesor_de_id, asesorado_de_id, nota? }] }
export const saveAsesoriasOrganigrama = async (negocioId, asesorias) => {
    try {
        const response = await axios.put(`${API_URL}/api/organigrama/asesorias`,
            { asesorias },
            {
                params: { negocio: negocioId },
                headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchPersonasFiltersAdminData = async (negocio) => {
    try {
        const response = await axios.post(`${API_URL}/api/personas/adminfilters`, {

            "current_page": 1,
            "items_per_page": 1000,
            "filteredWord": null,
            "rol": null,
            "departamento": null,
            "negocio": negocio,

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};